module.exports = __webpack_public_path__ + "media/flags/014-japan-6629b638.svg";